module.exports = __webpack_public_path__ + "static/media/reception-4.1d96752d.jpg";